export const ACCESS_TOKEN = "Access-Token-School"; // 用户token
export const TABS_ROUTES = "Tabs-Routes"; // 标签页
export const CHOSE_SCHOOL = "Chose-School"; // 选中的学校
